import { useEffect, useMemo } from "react";
import Router, { useRouter } from "next/router";
import { useVerifyEmailAddressMutation } from "@/generated/graphql";
import { getUrlWithQuery } from "@/libs/url";
import { ErrorCode, errorCodeIsIncluded, moveToErrorPage } from "@/libs/errors";
import useRollbarUtil from "../hooks/useRollbarUtil";

export const VerifyEmailPage = () => {
  const { rollbar } = useRollbarUtil();
  const router = useRouter();
  const token = useMemo(() => {
    return router.query.token as string;
  }, [router.query.token]);
  const { app } = router.query;

  const [verifyEmailAddressMutation] = useVerifyEmailAddressMutation({
    onCompleted: (data) => {
      if (data.verifyEmailAddress.result) {
        Router.push(getUrlWithQuery("/verify-email-address-completed", app));
      }
    },
    onError: (error) => {
      if (errorCodeIsIncluded(error, ErrorCode.SIGNED_IN_AS_ANOTHER_USER)) {
        Router.push(
          getUrlWithQuery("/verify-email-address-another-user", app, {
            token: token,
          })
        );
      } else {
        rollbar.error("Failed to verify email address", error);
        moveToErrorPage(ErrorCode.FAILED_TO_VERIFY_EMAIL_ADDRESS);
      }
    },
  });

  useEffect(() => {
    if (!token) return;
    verifyEmailAddressMutation({ variables: { input: { token } } });
  }, [token]);

  return <></>;
};
